import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowTriangleRight: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-triangle-right"><path d="M7.97419 4.29233C6.14866 3.37989 4 4.70668 4 6.74799V17.2519C4 19.2932 6.14866 20.62 7.97419 19.7076L18.4819 14.4556C20.5061 13.4439 20.506 10.556 18.4819 9.54431L7.97419 4.29233Z" fill="currentColor"/></CentralIconBase>;
};

export default IconArrowTriangleRight;
